import { z } from 'zod';
/**
 * Admin-facing Zod schemas for the conversation tags feature — a shared,
 * free-form label vocabulary an operator can attach to a conversation
 * (distinct from the LLM classification taxonomy in `topics.ts`, which the
 * model assigns automatically). Tag names are case-preserved but matched
 * case-insensitively at the store level; `TagDTO.usageCount` backs the
 * management screen's "N conversations" column.
 */
/**
 * Максимальная длина имени тега. ОДНА константа для контракта, поля ввода
 * (`TagInput maxLength`) и текста ошибки: зеркалит `CHECK (length(name)
 * BETWEEN 1 AND 40)` в БД (`packages/db/src/tag-store.ts` держит свою копию —
 * `db` от `admin-contracts` не зависит).
 */
export const TAG_NAME_MAX_LENGTH = 40;
export const TagId = z.string().uuid();
/** Minimal shape returned inline on a conversation (list item / detail). */
export const TagRefDTO = z.object({ id: TagId, name: z.string() });
/** Full shape returned by the tag-management screen. */
export const TagDTO = TagRefDTO.extend({
    usageCount: z.number().int().nonnegative(),
    createdAt: z.string().datetime(),
});
export const TagListQuery = z.object({
    q: z.string().trim().max(TAG_NAME_MAX_LENGTH).optional(),
    limit: z.coerce.number().int().min(1).max(200).optional(),
});
export const CreateTagRequest = z.object({
    name: z.string().trim().min(1).max(TAG_NAME_MAX_LENGTH),
});
export const RenameTagRequest = CreateTagRequest;
/**
 * Full replace of a conversation's tag set (not a diff/patch) — the client
 * sends names, not ids, so typing a brand-new tag name creates it inline
 * (mirrors how the reply-template picker and topic chips already work).
 */
export const SetConversationTagsRequest = z.object({
    names: z.array(z.string().trim().min(1).max(TAG_NAME_MAX_LENGTH)).max(20),
});
export const SetConversationTagsResponse = z.object({
    tags: z.array(TagRefDTO),
});
export const DeleteTagResponse = z.object({
    removedFromConversations: z.number().int().nonnegative(),
});
//# sourceMappingURL=tags.js.map